import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
// import Wrapper from '../Helpers/Wrapper';

const ModalSubscribe = (props) => {
  const [showModal, setShow] = useState(false);
  const [enteredEmail, setEmail] = useState('');
  const [enteredFirstName, setFirstName] = useState('');
  const [enteredLastName, setLastName] = useState('');
  const [emailFormat, setEmailFormat] = useState('');

  const emailChangeHandler = (event) => {
    setEmail(event.target.value);
  };
  const firstNameChangeHandler = (event) => {
    setFirstName(event.target.value);
  };
  const lastNameChangeHandler = (event) => {
    setLastName(event.target.value);
  };
  const emailformatChangeHandler = (event) => {
    setEmailFormat(event.target.value);
  };

  const showModalHandler = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  const submitHandler = async (event) => {
    // event.preventDefault();

    // // console.log(`Will try to submit to http://mcmta-md.us7.list-manage1.com/subscribe/post?u=a06f27da732da8f233eb295cc&amp;id=5dc57e0e3f`);

    // const formData = {
    //   u: 'a06f27da732da8f233eb295cc',
    //   id: '5dc57e0e3f',
    //   MERGE0: enteredEmail,
    //   MERGE1: enteredFirstName,
    //   MERGE2: enteredLastName,
    //   EMAILTYPE: emailFormat,
    //   submit: 'Subscribe'
    // };

    // console.log(formData);

    // // https://<dc>.api.mailchimp.com/2.0/lists/subscribe.json?apikey=<my_api_key>&id=<my_list_id>&email[email]=test@test.com&merge_vars[FNAME]=John&merge_vars[LNAME]=Doe&double_optin=false&send_welcome=false
    // // https://mcmta-md.us7.list-manage.com/subscribe/post?u=a06f27da732da8f233eb295cc&amp;id=5dc57e0e3f&amp;f_id=001dc2e4f0
    // const fetchResponse = await fetch(
    //   'https://mcmta-md.us7.list-manage.com/subscribe/post',
    //   {
    //     method: 'POST',
    //     headers: {'Content-Type': 'text/html'},
    //     body: JSON.stringify(formData),
    //     mode: 'no-cors'
    //   }
    //   );
    // console.log(`Fetch result: ${JSON.stringify(fetchResponse)}`)  

    handleClose();
  }
  return (
    <React.Fragment>
    <Row>
      <Button variant="outline-primary" size="md" onClick={showModalHandler}>
        Subscribe Now
      </Button>
      </Row>
      <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Subscribe to our mailing list</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <Container> */}
          All fields are mandatory.
          <hr />
          <Form action="https://mcmta-md.us7.list-manage.com/subscribe/post" method="POST" target="_blank">
          {/* <Form onSubmit={submitHandler}> */}
          <input type="hidden" name="u" value="a06f27da732da8f233eb295cc"></input>
          <input type="hidden" name="id" value="5dc57e0e3f"></input>
            <Form.Group className="mb-3">
              <Form.Control type="email" placeholder="Enter email" name="MERGE0" id="MERGE0" onChange={emailChangeHandler}/>
              <Form.Text className="text-muted">
                We'll never share your email with anyone else.
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control type="name" placeholder="First Name" name="MERGE1" id="MERGE1" onChange={firstNameChangeHandler} required/>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control type="name" placeholder="Last Name" name="MERGE2" id="MERGE2" onChange={lastNameChangeHandler} required/>
            </Form.Group>
            <Form.Text>Email format: </Form.Text>
            <div>
            <Form.Check inline label="HTML" value="html" type="radio" name="EMAILTYPE" id="EMAILTYPE_HTML"  onChange={emailformatChangeHandler} required checked/>
            <Form.Check inline label="Plain text" value="text" type="radio" name="EMAILTYPE" id="EMAILTYPE_TEXT" onChange={emailformatChangeHandler} required/>
            </div>
            <hr />
            <Row className="justify-content-center">
              <Button variant="outline-primary" size="md" type="submit"  onClick={submitHandler}>
                Subscribe
              </Button>
            </Row>
          </Form>
        </Modal.Body>
        {/* </Container> */}
      </Modal>
    </React.Fragment>
  );
};

export default ModalSubscribe;
